// extracted by mini-css-extract-plugin
export default {"root":"ChartText_root__-thAO","markdown":"ChartText_markdown__zJY+R","empty":"ChartText_empty__sRWex"};